/**
 * The grids run on DataGridPremium (the licence is Premium) but use only Pro features. Premium adds
 * row grouping, aggregation and pivoting to every column menu; our grids are sorted and filtered on
 * the server, so those client-side tools would only work on the loaded page. Spread this on every
 * DataGridPremium until a grid is built to use them.
 */
export const PREMIUM_FEATURES_OFF = {
    disableRowGrouping: true,
    disableAggregation: true,
    disablePivoting: true,
} as const;
